import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { ContactPage as ContactForm } from '../../components/ContactPage/ContactPage';
import { PageHero } from '../../components/PageHero/PageHero';
import warehousePic from '../../images/hero_warehouse.jpg';

export const ContactPage = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  return (
    <>
      <Helmet>
        <title>Contact Renuit Logistics — St. Petersburg, FL</title>
        <meta name="description" content="Contact Renuit Logistics for freight quotes, warehousing inquiries, or general support. Based in St. Petersburg, FL. Call (786) 628-3731 or email support@renuit.pro." />
        <link rel="canonical" href="https://www.renuit.pro/contact" />
        <meta property="og:title" content="Contact Renuit Logistics" />
        <meta property="og:description" content="Reach Renuit Logistics for freight, warehousing, or 3PL inquiries. St. Petersburg, FL. (786) 628-3731." />
        <meta property="og:url" content="https://www.renuit.pro/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.renuit.pro/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@RenuitLogistics" />
        <meta name="twitter:title" content="Contact Renuit Logistics" />
        <meta name="twitter:description" content="Reach Renuit Logistics for freight, warehousing, or 3PL inquiries. St. Petersburg, FL. (786) 628-3731." />
        <meta name="twitter:image" content="https://www.renuit.pro/og-image.jpg" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: 'Contact Renuit Logistics',
          url: 'https://www.renuit.pro/contact',
          mainEntity: {
            '@type': 'FreightForwarder',
            name: 'Renuit Logistics',
            url: 'https://www.renuit.pro/',
            telephone: '+17866283731',
            email: 'support@renuit.pro',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '360 Central Avenue, Office #310',
              addressLocality: 'St. Petersburg',
              addressRegion: 'FL',
              postalCode: '33701',
              addressCountry: 'US',
            },
          },
        })}</script>
      </Helmet>
      <PageHero
        image={warehousePic}
        tag="Get in Touch"
        heading="Let's Get Your Freight Moving"
        subheading="Call (786) 628-3731, email support@renuit.pro, or fill out the form — we respond within 24 hours."
      />
      <ContactForm isSubmitted={isSubmitted} setIsSubmitted={setIsSubmitted} />
    </>
  );
};
